'use client'

import type { FC } from 'react'
import type { LucideIcon } from 'lucide-react'

interface TeamPhilosophyCardProps {
  icon: LucideIcon
  title: string
  description: string
}

const TeamPhilosophyCard: FC<TeamPhilosophyCardProps> = ({
  icon: Icon,
  title,
  description,
}) => (
  <div className="flex flex-row sm:flex-col items-center sm:items-center gap-4 sm:gap-0 text-left sm:text-center">
    <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-green-100 rounded-full flex items-center justify-center shrink-0 sm:mx-auto sm:mb-4">
      <Icon className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-green-600" />
    </div>
    <div>
      <h3 className="text-sm sm:text-base font-semibold text-gray-900 mb-0.5 sm:mb-2">
        {title}
      </h3>
      <p className="text-xs sm:text-sm md:text-base text-gray-600 leading-relaxed">
        {description}
      </p>
    </div>
  </div>
)

export default TeamPhilosophyCard
